export default __webpack_public_path__ + "static/media/SampleSuspend.bcd13c6a.csv";